module.exports = __webpack_public_path__ + "static/media/3DPPA35.f3fa35e9.jpg";